import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Paper, Container, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import emailOutline from '@iconify/icons-eva/email-outline';
import phoneOutline from '@iconify/icons-eva/phone-outline';
import homeOutline from '@iconify/icons-eva/home-outline';
import { ContactForm } from '../components/_dashboard/user';
import { termsData } from '../DATA/DataText';

const useStyles = makeStyles((theme) => ({
  backgroundFix: {
    position: 'relative',
    height: '200px',
    marginTop: 120,
    width: '100%',
    backgroundColor: '#F78181',
    backgroundAttachment: 'fixed',
    zIndex: 2
  },
  centerTitleContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& h1': {
      fontFamily: 'Open Sans, sans-serif',
      fontSize: '37px',
      fontWeight: 500,
      color: 'white'
    }
  },
  centerTitle: {
    width: 400,
    height: 150,
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    '& h1': {
      fontSize: '37px',
      fontWeight: 500,
      color: 'white'
    },
    '& h3': {
      fontSize: '20px',
      fontWeight: 500,
      color: 'white',
      marginTop: 15
    }
  },
  gridContainer: {
    // backgroundColor: 'pink',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 50,
    marginTop: 100
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '2rem',
    color: 'black',
    marginTop: 10,
    fontFamily: 'Open Sans, sans-serif'
  },
  title: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '1.8rem',
    fontWeight: 700,
    color: 'black',
    marginBottom: 10
  },
  title1: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '0.9rem',
    fontWeight: 700,
    color: 'black',
    lineHeight: '50px',
    marginBottom: 10
  },
  list: {
    '& li': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '2rem',
      color: 'black',
      marginTop: 10,
      fontFamily: 'Open Sans, sans-serif'
    }
  }
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  textAlign: document.body.dir === 'ltr' ? 'left' : 'right',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#f78181',
    border: '1px solid #f78181',
    alignItems: 'flex-start',
    verticalAlign: 'top',
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    alignItems: 'flex-start',
    verticalAlign: 'top',
    border: '1px solid #f78181',
    padding: 20
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  backgroundColor: theme.palette.action.hover
}));

const PolitiqueConfidentialite = () => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();
  const [dir, setDir] = useState(document.body.dir);

  return (
    <div>
      <Grid container xs={12} className={classes.backgroundFix}>
        <Box className={classes.centerTitleContainer}>
          <h1>{t('PolitiqueConfidentialité')}</h1>
        </Box>
      </Grid>
      <Container maxWidth="md" style={{ marginBottom: 200 }}>
        <Grid container xs={12} className={classes.gridContainer}>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.text}>{t('accèsàcertainessections')}</Typography>
            <Typography className={classes.text}>{t('LaprésentePolitique')}</Typography>
            <Typography className={classes.text}>{t('SmileLandseréserve')}</Typography>
            <Typography className={classes.text}>{t('Enacceptantlaprésente')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>1. {t('Définitionss')}</Typography>
            <Typography className={classes.text}>{t('Définitiondestermes')}</Typography>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Autoritédesurveillance')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('désigneuneautorité')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('DonnéesPersonnelles')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('désignetouteinformation')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('SmileLand')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('DésignelasociétéSmileLand')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('LesapplicationsSmileland')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Désignelasuite')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Partenairesaffaires')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Désignelescrèches')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('PolitiquedeConfidentialité')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('désignelaprésentePolitique')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('RèglementationApplicable')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Ildelaloiédictée')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Traitement')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('désignetouteopération')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Tiers')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('désignetoutepersonne')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Utilisateu')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('désignetoutepersonnephysique')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Violationdesdonnées')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('désigneuneviolationde')}
              </Typography>
            </Box>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>
              2. {t('TraitementsDonnéesPersonnelles')}
            </Typography>
            <Typography className={classes.text}>
              <strong>2.1. </strong> {t('Cettepolitiquedeconfidentialité')}
            </Typography>
            <Typography className={classes.text}>{t('Laconnexionavec')}</Typography>
            <Typography className={classes.text}>{t('Touteinformationpartielle')}</Typography>
            <Typography className={classes.text}>
              <strong>2.2. </strong> {t('Lesfinalitésdutraitement')}
            </Typography>
            <Typography className={classes.text}>
              <strong>1. </strong>
              {t('Traiterlesdemandes')}
            </Typography>
            <Typography className={classes.text}>
              <strong>2. </strong>
              {t('Aprèsapprobation')}
            </Typography>
            <Typography className={classes.text}>
              <strong>3. </strong>
              {t('traiteretrépondre')}
            </Typography>
            <Typography className={classes.text}>
              <strong>4. </strong>
              {t('Analyserlafréquentation')}
            </Typography>
            <Typography className={classes.text}>{t('Danscasvousbénéficiez')}</Typography>
            <Typography className={classes.text}>{t('utilisateursouhaiteannuler')}</Typography>
            <Typography className={classes.text}>
              <strong>2.3. </strong>
              {t('Letableaufigurant')}
            </Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('objetetlesfinalité')}</li>
              <li>{t('lespersonnesconcernées')}</li>
              <li>{t('lescatégoriesdeDonnées')}</li>
              <li>{t('lesdestinataires')}</li>
              <li>{t('laduréedeconservation')}</li>
            </ul>
          </Box>
          <TableContainer component={Paper} style={{ borderRadius: 0 }}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>{t('objetetlesfinalité')}</StyledTableCell>
                  <StyledTableCell>{t('lespersonnesconcernées')}</StyledTableCell>
                  <StyledTableCell>{t('lescatégoriesdeDonnées')}</StyledTableCell>
                  <StyledTableCell>{t('lesdestinataires')}</StyledTableCell>
                  <StyledTableCell>{t('laduréedeconservation')}</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    1. {t('Demandederéservation')}
                  </StyledTableCell>
                  <StyledTableCell>{t('Gestionnairesdescrèches')}</StyledTableCell>
                  <StyledTableCell>
                    <span>{t('Informationspersonne')}</span>
                    <ul>
                      <li>{t('Nometprénom')}</li>
                      <li>{t('Lenomcomplet')}</li>
                      <li>{t('Nationalité')}</li>
                      <li>{t('adresse')}</li>
                      <li>{t('email')}</li>
                      <li>{t('Numérodetéléphone')}</li>
                    </ul>
                  </StyledTableCell>
                  <StyledTableCell>{t('GestionnumériquedeSmileLand')}</StyledTableCell>
                  <StyledTableCell rowSpan={3}>{t('Smilelandconservera')}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    2. {t('lesapplicationsSmileLand')}
                  </StyledTableCell>
                  <StyledTableCell>{t('GestionnumériquedeSmileLand')}</StyledTableCell>
                  <StyledTableCell>
                    <ul>
                      <li>{t('NometPrénom')}</li>
                      <li>{t('email')}</li>
                      <li>{t('leNumérodetéléphone')}</li>
                    </ul>
                  </StyledTableCell>
                  <StyledTableCell rowSpan={2}>{t('Lesdonnéesnesontpas')}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    3. {t('Demandesderenseignements')}
                  </StyledTableCell>
                  <StyledTableCell>{t('Serviceàlaclientèle')}</StyledTableCell>
                  <StyledTableCell>
                    <ul>
                      <li>{t('NometPrénom')}</li>
                      <li>{t('vousrenseigner')}</li>
                    </ul>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Typography className={classes.text}>
            <strong>2.4. </strong>
            {t('SmileLandengage')}
          </Typography>
          <Box style={{ marginBottom: 30, marginTop: 30 }}>
            <Typography className={classes.title}>3. {t('Déléguéprotectiondesdonnées')}</Typography>
            <Typography className={classes.text}>{t('Smilelandanommé')}</Typography>
            <Typography className={classes.text}>{t('Mmenomprénom')}</Typography>
            <Typography className={classes.text}>{t('Déléguéàlaprotection')}</Typography>
            <Typography className={classes.text}>
              {t('adressedusiègesocial')}
              <font color="blue"> smileland@gmail.dz.</font>
            </Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>
              4. {t('Procéduresorganisationnelles')}
            </Typography>
            <Typography className={classes.text}>
              <strong>4.1. </strong>
              {t('SmileLandmetenœuvre')}
            </Typography>
            <Typography className={classes.text}>{t('EnparticulierSmileland')}</Typography>
            <Typography className={classes.text}>
              <strong>4.2. </strong>
              {t('Lesmesurestechniques')}
            </Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>5. {t('DemandesdeTiers')}</Typography>
            <Typography className={classes.text}>{t('SmileLandengageànepasdivulguer')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>6. {t('DroitsdesUtilisateurs')}</Typography>
            <Typography className={classes.text}>
              <strong>6.1. </strong>
              {t('LasociétéSmileLandgarantitàutilisateur')}
            </Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('Obtenirlaconfirmation')}</li>
              <li>{t('Decorrigercompléterdonnées')}</li>
              <li>
                {t('Obtenirlasuppressiondonnées')}
                <ul
                  className={classes.list}
                  style={{
                    padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
                  }}
                >
                  <li>{t('lesDonnéesplusnécessaires')}</li>
                  <li>{t('lesDonnéesfaitobjettraitement')}</li>
                  <li>{t('Personnellesdoiventêtreeffacées')}</li>
                  <li>{t('Résiliationdéfinitive')}</li>
                </ul>
              </li>
              <li>{t('delimitationdesTraitements')}</li>
              <li>{t('portabilitédesesDonnées')}</li>
            </ul>
            <Typography className={classes.text}>
              <strong>6.2. </strong>
              {t('Pourexercerdecesdroits')}
              <font color="blue">smileland@gmail.dz.</font>
            </Typography>
            <Typography className={classes.text}>{t('SmilLandengageaccuserréception')}</Typography>
            <Typography className={classes.text}>
              <strong>6.3. </strong>
              {t('Enoutrelesutilisateurs')}
            </Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>7. {t('Confidentialité')}</Typography>
            <Typography className={classes.text}>{t('SmileLandengageque')}</Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('neTraiterqueDonnées')}</li>
              <li>{t('cequelesDonnéesPersonnelles')}</li>
              <li>{t('prendretouteslesmesures')}</li>
              <li>{t('encasdecessation')}</li>
              <li>{t('informerimmédiatemen')}</li>
            </ul>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>
              8. {t('TransfertDonnéesPersonnelles')}
            </Typography>
            <Typography className={classes.text}>{t('LasociétéSmileLandtransfère')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>
              9. {t('ViolationdeDonnéesPersonnelles')}
            </Typography>
            <Typography className={classes.text}>
              <strong>9.1. </strong>
              {t('SmilelandIDLM')}
            </Typography>
            <Typography className={classes.text}>
              <strong>9.2. </strong>
              {t('Toutefoisinformations')}
            </Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('SmileLandœuvre')}</li>
              <li>{t('SmileLandprismesuresultérieures')}</li>
              <li>{t('Dansinformations')}</li>
            </ul>
            <Typography className={classes.text}>
              <strong>9.3. </strong>
              {t('LasociétéSmileLandnotifiera')}
            </Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>10. {t('Dispositionsgénérales')}</Typography>
            <Typography className={classes.text}>
              <strong>10.1. </strong>
              {t('Encasdeconflitentre')}
            </Typography>
            <Typography className={classes.text}>
              <strong>10.2. </strong>
              {t('Siquelconquedesstipulations')}
            </Typography>
            <Typography className={classes.text}>
              <strong>10.3. </strong>
              {t('SmileLandpeutmodifierPolitique')}
            </Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>
              11. {t('Suppression du compte et des données')}
            </Typography>
          </Box>
        </Grid>
      </Container>
    </div>
  );
};

export default PolitiqueConfidentialite;
